@if (answers[0].photo) {
  <div class="img-control-wrapper">
    @for (answer of answers; track answer) {
      <lib-img-radio-btn
        [img]="answer.photo.url1x"
        [value]="answer.id"
        [formControl]="form"
        [styleClass]="getStyleClass(answer)"
      ></lib-img-radio-btn>
    }
  </div>
} @else {
  <div class="control-wrapper">
    @for (answer of answers; track answer; let i = $index) {
      <lib-abc-radio-btn
        [index]="i"
        [formControl]="form"
        [value]="answer.id"
        [styleClass]="getStyleClass(answer)"
        [innerHTML]="answer.text | safe: 'html'"
      >
      </lib-abc-radio-btn>
    }
  </div>
}
